import React from "react";

const SectionTitle = ({ script, title, subtitle, align = "center", light = false }) => {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      {script && (
        <p className="font-script text-4xl md:text-5xl gold-gradient-text leading-none p-2">
          {script}
        </p>
      )}
      <h2 className="font-cinzel text-2xl md:text-4xl gold-gradient-text tracking-[0.18em] uppercase mt-1">
        {title}
      </h2>
      {subtitle && (
        <div className="flex items-center gap-3 mt-5">
          <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
          <span className="text-[#7D6A42] text-[10px] uppercase tracking-[0.4em] font-cinzel">
            {subtitle}
          </span>
          <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
